import React, {FC} from 'react'

import cn from 'classnames/bind'

import {Col, Container, Row} from 'components/elements/grid'

import s from './FormHeader.module.scss'
const cx = cn.bind(s)

interface IFormHeaderProps {
	title: string
	button: JSX.Element
	className?: string
}

const FormHeader: FC<IFormHeaderProps> = ({title, button, className}) => {
	return (
		<div className={cx(className)}>
			<Container>
				<Row>
					<Col>
						<header className={cx('header')}>
							<div className={cx('header__right')}>{button}</div>
							<h2 className={cx('header__title', 'step__title')}>{title}</h2>
						</header>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

FormHeader.displayName = 'FormHeader'

export default FormHeader
